export default __webpack_public_path__ + "17e6c6294be4eecc3c6a96cf8ae14281.svg";